<template>
  <div class="upload-file">
    <div class="upload-btn">
      <div class="btn-text">选择文件</div>
      <input id="upload-input" @change="fileChange" type="file" ref="file"
             accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></input>
    </div>
    <div class="confirm-btn" @click="addUnitMemberByFile">确定</div>
    <div class="file-name">{{ fileName }}</div>
  </div>
</template>

<script>
export default {
  name: 'uploadFile',
  data() {
    return {
      unitNo: '',
      file: null,
      cookieStr: '',
    }
  },
  computed: {
    fileName() {
      return this.file && this.file.name || '';
    },
  },
  mounted() {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    document.cookie = "";
    this.unitNo = this.$route.query.unitNo || '';
    this.cookieStr = this.$route.query.cookie || '';
    this.cookieStr = this.cookieStr + ';Path=/';
    if (this.cookieStr) {
      this.cookieStr = this.cookieStr.replace(",", ";");
      document.cookie = this.cookieStr;
      console.log('document.cookie:' + document.cookie);
    }
  },
  methods: {
    fileChange() {
      this.file = this.$refs.file.files[0];
    },
    addUnitMemberByFile() {
      let self = this;
      let params = {
        unitNo: this.unitNo,
        uploadFile: this.file
      };
      let formData = new window.FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      this.$http.post('/managementPlatform/unit/addUnitMemberByFile', formData).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          if (res.message) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
          }
          return;
        }
        self.$message({
          type: "success",
          message: '上传成功!',
          center: true
        });
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-file {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;

  .upload-btn {
    position: relative;
    display: inline-block;
    width: 80px;
    height: 28px;
    overflow: hidden;
    border-radius: 17px;
    border: 1px solid #3B98F7;
    color: #3B98F7;

    #upload-input {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 80px;
      height: 30px;
      opacity: 0;
    }

    .btn-text {
      position: absolute;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
    }
  }

  .confirm-btn {
    float: right;
    padding: 10px;
    vertical-align: top;
    font-size: 12px;
    color: #3B98F7;
  }

  .file-name {
    margin-top: 15px;
    font-size: 14px;
    color: #333;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/uploadFile.vue